import { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default memo(function HeaderBreadCrumbVod(props) {
  const { page } = props;

  const location = useLocation();

  const [, , subPage] = location.pathname.split('/');

  return (
    <div className="header__breadcrumb-wrapper">
      <nav className={`header__breadcrumb  ${page}`}>
        <ul>
          <li>
            <Link to="/">HOME</Link>
          </li>
          <li>
            <Link to={`/${page}`}>{page.toUpperCase()}</Link>
          </li>
          {subPage && <li>{subPage}</li>}
        </ul>
      </nav>
    </div>
  );
});
